import { Validators } from '@biteinc/common';
/**
 * Schema for the ordered item as it appears in requests.
 * Note that this schema differs from the database schema.
 */
export const orderedItemSchema = {
    displayName: 'ordered item',
    type: 'object',
    fields: {
        _id: {
            type: 'mongoId',
            required: true,
            isPermanent: true,
        },
        scannedBarcode: {
            type: 'keyString',
            validationRegex: Validators.barcodeRegexString,
            isPermanent: true,
        },
        // TODO: remove this field; currently needed for backwards compatibility with old GCN versions
        vendor: {
            type: 'object',
            isPermanent: true,
            fields: {
                _id: {
                    type: 'mongoId',
                    required: true,
                },
            },
        },
        vendorId: {
            type: 'mongoId',
            isPermanent: true,
            // TODO: Uncomment required flag when vendor field is removed
            // required: true,
        },
        // TODO: remove this field; currently needed for backwards compatibility with old GCN versions
        section: {
            type: 'object',
            isPermanent: true,
            fields: {
                _id: {
                    type: 'mongoId',
                    required: true,
                },
            },
        },
        sectionId: {
            type: 'mongoId',
            isPermanent: true,
            // TODO: Uncomment required flag when section field is removed
            // required: true,
        },
        specialRequest: {
            type: 'keyString',
            validationRegex: Validators.simpleStringRegexString({
                allowCommas: true,
                allowDiacritics: true,
            }),
            // char limitations: no special characters in case we need to print it
        },
        recipientName: {
            type: 'keyString',
            validationRegex: Validators.simpleStringRegexString({
                maxLength: 32,
                allowDiacritics: true,
            }),
        },
        recipientNumber: {
            type: 'int',
            min: 1,
        },
        upsellScreen: {
            type: 'shortString',
        },
        priceOption: {
            type: 'object',
            subtype: 'OrderedPriceOption',
            required: true,
        },
        orderedItemId: {
            type: 'mongoId',
        },
    },
};
//# sourceMappingURL=ordered_item_schema.js.map